import { useId, useState } from 'react';
import { Link } from 'react-router-dom';
import { Switch } from '../Switch';
import { useSubmit } from '../../../hooks/useSubmit';
import { demoNewsletterLink, newRequestId, subscribeNewsletter } from '../../../utils/api';
import { newsletterConsent } from '../../../data/consent';
import { legalLinks } from '../../../data/legal';
type Props = {
  email: string;
  subscribed: boolean;
  /** Afmelden: gewoon de voorkeur uitzetten (de server meldt haar bij Brevo af). */
  onUnsubscribe: () => void;
};

/**
 * De nieuwsbrief in Mijn omgeving. Afmelden kan direct; aanmelden niet via een schakelaar, want
 * toestemming moet aantoonbaar zijn: net als in de footer gaat er een bevestigingsmail uit, met de
 * toestemmingstekst die ze hier ziet (`consentVersion`). Pas na de klik staat ze op de lijst en wordt
 * de voorkeur `true` (dat doet de server, niet de site).
 */
export function NewsletterPref({
  email,
  subscribed,
  onUnsubscribe
}: Props) {
  const signup = useSubmit(subscribeNewsletter);
  const [askedFor, setAskedFor] = useState<string | null>(null);
  const consentId = useId();
  if (subscribed) {
    return <Switch checked onChange={onUnsubscribe} label="Nieuwsbrief" hint="Eén keer per maand, over huid en seizoen." className="py-4" data-id="element-6766" data-mp="3eytr7yxadf6u" />;
  }
  const pending = signup.succeeded && askedFor === email;
  return <div className="py-4" data-id="element-6767" data-mp="3590ozoj1acf9">
      <Switch checked={false} disabled={signup.submitting || pending} onChange={() => {
      setAskedFor(email);
      signup.submit({
        requestId: newRequestId(),
        email,
        source: 'account',
        consentVersion: newsletterConsent.version
      });
    }} label="Nieuwsbrief" hint="Eén keer per maand, over huid en seizoen." describedBy={consentId} data-id="element-6768" data-mp="3588y2r0dt2vb" />
      {/* Buiten de schakelaar: een link binnen een knop is niet aan te klikken of voor te lezen. */}
      <p id={consentId} className="mt-1.5 pr-16 text-[13px] leading-relaxed text-muted" data-id="element-6769" data-mp="ggoibalnt5pd">
        {newsletterConsent.text}{' '}
        <Link to={legalLinks.privacy} className="underline underline-offset-2 hover:text-ink" data-id="element-6770" data-mp="1thkmc2iehnqo">
          Privacybeleid
        </Link>
      </p>
      <p role="status" className="mt-2 text-[13px] leading-relaxed text-ink empty:hidden" data-id="element-6771" data-mp="1ogeue6wke4i7">
        {signup.submitting ? 'Even versturen…' : pending ? `Bijna klaar: bevestig je aanmelding via de mail naar ${email}.` : ''}
      </p>
      {pending && demoNewsletterLink && <Link to={demoNewsletterLink} className="mt-1 inline-block text-[13px] text-clay underline underline-offset-4 hover:text-ink" data-id="element-6772" data-mp="2c6hhe8lmgk9y">
          Open de bevestigingslink (demo)
        </Link>}
      {signup.error && <p role="alert" className="mt-2 text-[13px] text-clay" data-id="element-6773" data-mp="23dnwnvneosop">
          {signup.error}
        </p>}
    </div>;
}